import { atom } from 'recoil';

export const filterAtom = atom({
  key: 'filterAtom',
  default: {
    search: '',
    topic: 'all',
    type: 'all',
    page: 1,
    limit: 6
  }
});

export const topicsAtom = atom({
  key: 'topicsAtom',
  default: []
});

export const mediaAtom = atom({
  key: 'mediaAtom',
  default: []
});

export const paginationAtom = atom({
  key: 'paginationAtom',
  default: {
    total: 0,
    page: 1,
    limit: 6,
    totalPages: 0
  }
});

export const mediaFetchKeyAtom = atom({
  key: 'mediaFetchKeyAtom',
  default: null
});

export const topicsLoadedAtom = atom({
  key: 'topicsLoadedAtom',
  default: false
});

export const siteContentAtom = atom({
  key: 'siteContentAtom',
  default: {
    hero_heading: 'Here are the tools to tell our story.',
    intro_text: "We have a great story. We do essential things for humankind.\nWe are one of the most technologically advanced industries on the planet.\nModern life doesn't happen without us. So, let's get our story out.",
    toolbox_heading: "Here's how to use our messaging toolbox.",
    toolbox_text: "We've included a variety of video, print, digital and social assets intended for broad use by IADC Members and the drilling industry. Assets can be filtered by topic and/or media type and downloaded directly from the portal. For a list of suggested uses for this material [CLICK HERE](/uses). Please contact IADC with specific requests or to inquire about Member branding options: [marketing@iadc.org](mailto:marketing@iadc.org).",
    campaign_uses_heading: 'How to Use the Campaign Materials'
  }
});

export const siteContentLoadedAtom = atom({
  key: 'siteContentLoadedAtom',
  default: false
});
